import styled from "@emotion/styled";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  CreatePortModal,
  SmsStatusNavbar,
  SmsStatusPanel
} from "../components";

const Container = styled.div`
  width: 100%;
  padding: 32px;
  background: white;
  grid-column: 2 / span 2;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const SmsStatus = () => {
  const [activeTab, setActiveTab] = useState("message");
  const { t } = useTranslation();

  return (
    <Container>
      <CreatePortModal />
      <SmsStatusNavbar
        tabs={[{ name: t("message.smsStatus.MessageStatus"), key: "message" }]}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />
      {activeTab === "message" && <SmsStatusPanel />}
    </Container>
  );
};
